import Reports from "./Reports/Route";
import Settings from "./Settings/Routes";
import Appointed from "./Appointed/Routes";
import Attendances from "./Attendances/Routes";
import ParadeTypes from "./ParadeTypes/Routes";
import CreateParade from "./CreateParade/Route";
import CampParade from "./CampParade/Route";
import ManPower from "./Reports/ManPower/Routes";
import ParadeEscape from "./ParadeEscape/Routes";
import EventReports from "./Reports/Parade/Routes";
import PublishPartOne from "./PublishPartOne/Routes";
import ERE from "./ERE/Routes";

export default [...CreateParade, ...CampParade, ...Reports, ...ParadeTypes, ...PublishPartOne, ...ManPower, ...Appointed, ...EventReports, ...ParadeEscape, ...Attendances, ...Settings, ...ERE];
